import { Injectable } from "@angular/core";
import { PushNotificationsService } from "app/services/push-notifications.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NavbarService {
  private searchOpenSource = new BehaviorSubject<boolean>(false);
  searchOpen$ = this.searchOpenSource.asObservable();

  private notificationOpenSource = new BehaviorSubject<boolean>(false);
  notificationOpen$ = this.notificationOpenSource.asObservable();

  private unreadPushNotifications = new BehaviorSubject<number>(0);
  public unreadPushNotifications$ = this.unreadPushNotifications.asObservable();

  constructor() // private pushService: PushNotificationsService

  {
    // this.pushService.stats$.subscribe((stats) => {
    //   if (stats) {
    //     // Considérer les notifications en échec comme "non lues" pour alerter
    //     this.unreadPushNotifications.next(stats.totalFailed);
    //   }
    // });
  }

  public getUnreadPushCount(): number {
    return this.unreadPushNotifications.value;
  }

  toggleSearch() {
    this.searchOpenSource.next(!this.searchOpenSource.value);
  }

  toggleNotification() {
    this.notificationOpenSource.next(!this.notificationOpenSource.value);
  }
}
